<template>
  <div
    class="c-masthead"
    :class="{ center: fields?.center?.value === true, padding: fields?.padding?.value === true }"
  >
    <div class="c-masthead__inner">
      <sc-image v-if="fields && fields.image" :media="fields.image" class="c-masthead__icon" />
      <h1 v-if="fields && fields.heading" v-html="fields.heading.value" />
      <h2 v-if="fields && fields.subheading" v-html="fields.subheading.value" />
      <h3 v-if="fields && fields.subsubheading" v-html="fields.subsubheading.value" />
      <sc-text tag="p" v-if="fields && fields.lead" :field="fields.lead" class="c-masthead__lead" />
      <sc-link
        v-if="fields && fields.cta1 && fields.cta1.value.text"
        :field="fields.cta1"
        class="c-cta--primary"
        :class="fields.cta1.value.class"
      />
      <sc-link
        v-if="fields && fields.cta2 && fields.cta2.value.text"
        :field="fields.cta2"
        class="c-cta--primary second"
        :class="fields.cta2.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Text, Link, Image } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Masthead',
  components: {
    ScText: Text,
    ScLink: Link,
    ScImage: Image
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.c-masthead {
  @include padding-y(5rem, 4rem);
  color: $white;
  background: linear-gradient(
    169deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 59, 92, 1) 20%,
    rgba(0, 134, 191, 1) 100%
  );

  @include tablet-up {
    @include padding-y(5rem);
  }

  &__inner {
    @include padding-x-thin;
  }

  &.padding {
    padding-bottom: 33rem;

    @include tablet-up {
      padding-bottom: 18rem;
    }
  }
  &.center {
    .c-masthead__inner {
      text-align: center;
      margin: 0 auto;
      @include desktop-up {
        width: 85%;
      }
    }

    h1 {
      @include phone-only {
        font-size: 3.6rem;
        line-height: 4.2rem;
      }
    }
  }

  &__inner {
    h1,
    h2,
    h3,
    p,
    span {
      color: $white;
    }

    h1,
    h2 {
      -webkit-text-fill-color: $white;
    }

    h1 {
      margin-top: 0;
    }

    h3 {
      @include phone-only {
        font-size: 2rem;
        line-height: 2.6rem;
      }
    }
  }

  &__icon {
    margin-bottom: 2rem;
  }

  &__lead {
    margin-top: 2rem;
  }

  &__cta {
    margin-top: 2rem;
    margin-right: 4rem;
    display: inline-block;
    background-color: $orange;
    color: $white;
    padding: 1.3rem 8rem calc(1.3rem * 1.2) 8rem;
    text-transform: uppercase;
    border-radius: 0.25rem;
    @include tablet-down {
      width: 100%;
      margin-right: 0;
      @include padding-x(2em);
      text-align: center;
    }

    &:hover,
    &:focus,
    &:active {
      color: $white;
      text-decoration: none;
      background-color: $dark-orange;

      span {
        &::after {
          left: 1rem;
        }
      }
    }

    span {
      &::after {
        position: relative;
        display: inline-block;
        content: '';
        background-image: url(~@/assets/images/icon-arrow-right-white-mobile.svg);
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 1rem;
        width: 1.6rem;
        height: 1.2rem;
        transition: 0.25s;
        top: 0;
        left: 0;
      }
    }
  }

  .second {
    @include tablet-up {
      margin-left: 4rem;
    }
  }
}
</style>
